export const NOTIFICATION_TYPES = {
    warning: 'warning',
    information: 'information',
    recommendation: 'recommendation',
}
